<template>
    <re-b-modal ref="entityPick" header="选择" hide-footer large fit-content>
        <query-view :config-code="configCode" v-bind="$attrs"
                    skip-path-query disable-row-check disable-export
                    withCustomActionsHeadOfRow>
            <template #headOfRow="{row}">
                <b-button variant="outline-primary"
                          @click="selected(row)">
                    <i class="fa-regular fa-square-check"></i>
                </b-button>
            </template>
        </query-view>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";

export default {
    name: "QgEntityPick",
    components: {QueryView: () => import('@/components/common/display/query-view/QueryView.vue'), ReBModal},
    props: {
        configCode: String,
    },
    methods: {
        showModal() {
            this.$refs.entityPick.showModal();
        },
        selected(row) {
            this.$emit('selected', row);
            this.$refs.entityPick.hide();
        },
    }
}
</script>

<style scoped>

</style>
